module.exports = __webpack_public_path__ + "media/mejorGol.a022721f.mp4";